export default __webpack_public_path__ + "static/media/Support.b7c6d7b7.png";